/**
 * Pestañas de la sección **Recobros** (2026-08-10).
 *
 * Antes eran cuatro pantallas hermanas que se enlazaban entre sí con botones
 * distintos en cada una, cada una volviendo a un sitio diferente (y la Cartera
 * sin vuelta ninguna). Pero no son cuatro cosas: son cuatro **vistas del mismo
 * hecho** — los clientes que deben dinero.
 *
 *   · Cartera     — todo el dinero, agrupado por la decisión que toca.
 *   · Mi cola     — lo que hay que hacer hoy (un filtro de lo anterior).
 *   · Casos       — los episodios, para investigar uno concreto.
 *   · Condonados  — el registro de lo perdonado.
 *
 * La regla que ordena esto: una VISTA es un recorte filtrado de lo mismo y va
 * como pestaña; una PANTALLA es una entidad con dirección propia (el cliente,
 * el caso). El panel venía ascendiendo vistas a pantallas, y por eso el menú
 * crecía sin parar.
 *
 * Cadencias y Shadow NO están aquí a propósito: son configuración y
 * diagnóstico, no trabajo diario, y no deben competir por la atención con la
 * cola. Viven en el pie de la sección.
 */
import { Link, useLocation } from "react-router-dom";

/**
 * Nombres que dicen QUÉ hay dentro, no jerga interna (2026-08-10). «Cartera» y
 * «Condonados» no le decían nada a quien entra por primera vez: ahora se
 * nombran por su contenido — el dinero pendiente y la deuda perdonada.
 */
const TABS = [
  { to: "/operations/recobros/cartera", label: "Deuda por cliente" },
  { to: "/operations/recobros/tareas", label: "Mis tareas" },
  { to: "/operations/recobros", label: "Casos abiertos", exact: true },
  { to: "/operations/recobros/condonados", label: "Deuda perdonada" },
];

const COLORS = {
  ink: "#212529",
  muted: "#6c757d",
  border: "#dee2e6",
  active: "#0d6efd",
};

export default function RecobrosTabs() {
  const { pathname } = useLocation();

  return (
    <nav
      aria-label="Vistas de recobros"
      style={{
        display: "flex",
        gap: "0.25rem",
        borderBottom: `1px solid ${COLORS.border}`,
        marginBottom: "1rem",
        flexWrap: "wrap",
      }}
    >
      {TABS.map((t) => {
        const active = t.exact ? pathname === t.to : pathname.startsWith(t.to);
        return (
          <Link
            key={t.to}
            to={t.to}
            aria-current={active ? "page" : undefined}
            style={{
              padding: "0.45rem 0.85rem",
              textDecoration: "none",
              fontSize: ".88rem",
              fontWeight: active ? 600 : 400,
              color: active ? COLORS.active : COLORS.muted,
              borderBottom: `2px solid ${active ? COLORS.active : "transparent"}`,
              marginBottom: "-1px",
            }}
          >
            {t.label}
          </Link>
        );
      })}
      <span style={{ marginLeft: "auto", display: "flex", gap: "0.6rem", alignItems: "center" }}>
        <Link
          to="/operations/recobros/cadencias"
          style={{ fontSize: ".78rem", color: COLORS.muted }}
        >
          Cadencias
        </Link>
        <Link
          to="/operations/recobros/auto-recobro"
          style={{ fontSize: ".78rem", color: COLORS.muted }}
        >
          Reintento de cobro
        </Link>
        <Link
          to="/operations/recobros/shadow"
          style={{ fontSize: ".78rem", color: COLORS.muted }}
        >
          Decisiones
        </Link>
      </span>
    </nav>
  );
}
